import { useGetMerchantFeatureFlags } from "./queries/useMerchantQueries";

// Hard kill-switch driven by a build-time env flag (set only in production).
// While Airtel is not ready in production we must never show it, even if the
// features endpoint returns airtel=true or fails and refetches. Remove this
// constant + the guard below (and VITE_APP_FORCE_DISABLE_AIRTEL from
// .env.production) once the backend serves Airtel in production.
const AIRTEL_FORCE_DISABLED =
  import.meta.env.VITE_APP_FORCE_DISABLE_AIRTEL === "true";

// Single source of truth for whether Airtel is offered as a mobile money
// option. Strict `=== true` so loading/error states fail closed (hidden)
// rather than accidentally showing Airtel before the flag resolves.
export function useAirtelEnabled() {
  const { data: featureFlags } = useGetMerchantFeatureFlags();
  if (AIRTEL_FORCE_DISABLED) return false;
  return featureFlags?.airtel === true;
}
